import HttpClient from 'flow-doctor-lib/constants/HttpClient';
import { registerQuery } from 'data-fetching-client';
export const FETCH_PROPERTY_SOURCE = registerQuery({
  fieldName: 'fetchPropertySource',
  args: ['portalId', 'propertySource', 'sourceId'],
  fetcher({
    portalId,
    propertySource,
    sourceId
  }) {
    return HttpClient.post('source-interpretation/v1/core', {
      data: {
        propertySource,
        sourceId
      },
      query: {
        portalId
      }
    });
  }
});